"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inject_typesafe_react_1 = require("inject-typesafe-react");
/**
 * Hook to return the AccountService from the context (via useService).
 */
function useAccountService() {
    return inject_typesafe_react_1.useServices(function (services) { return services.accountService(); });
}
exports.useAccountService = useAccountService;
//# sourceMappingURL=useAccountService.js.map